import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FiArrowDownRight, FiHeart } from "react-icons/fi";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/main.scss";

function Main() {
  const { toggleWishlist, isWishlisted } = useContext(CartContext);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="new-home">
      <section className="signal-hero" aria-labelledby="signal-title">
        <div className="signal-copy">
          <span className="signal-index">IR / 001</span>
          <p>Independent design objects for daily movement</p>
          <h1 id="signal-title">Colour<br />changes<br />the outline.</h1>
          <Link to="/shop" onClick={toTop}>View the catalogue <FiArrowDownRight /></Link>
        </div>
        <div className="signal-image">
          <span className="shape shape-one" aria-hidden="true" />
          <img src={productData[0].image} alt={productData[0].name} />
          <span className="vertical-note">DROP 01 · FUNCTION / COLOUR / FORM</span>
        </div>
      </section>

      <section className="manifesto-strip" aria-label="Design principles">
        <p>Useful details</p><p>Decisive colour</p><p>Small, focused catalogue</p>
      </section>

      <section className="catalogue-preview" aria-labelledby="catalogue-title">
        <header>
          <div>
            <p className="eyebrow">Current release</p>
            <h2 id="catalogue-title">Six pieces,<br />one clear signal.</h2>
          </div>
          <p>{siteConfig.description}</p>
        </header>

        <div className="signal-grid">
          {productData.map((product, index) => (
            <article className="signal-card" key={product.id}>
              <Link className="signal-card-image" to={`/shopDetails/${product.id}`} onClick={toTop}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <img src={product.thumbnail} alt={product.name} loading={index < 2 ? "eager" : "lazy"} />
              </Link>
              <div className="signal-card-info">
                <div>
                  <Link to={`/shopDetails/${product.id}`} onClick={toTop}>{product.name}</Link>
                  <small>{product.category}</small>
                </div>
                <span>{formatPrice(product.price)}</span>
                <button type="button" onClick={() => toggleWishlist(product.id)} aria-label={`${isWishlisted(product.id) ? "Remove" : "Add"} ${product.name} ${isWishlisted(product.id) ? "from" : "to"} wishlist`}>
                  <FiHeart className={isWishlisted(product.id) ? "is-active" : ""} />
                </button>
              </div>
            </article>
          ))}
        </div>
        <Link className="catalogue-link" to="/shop" onClick={toTop}>Open full catalogue <FiArrowDownRight /></Link>
      </section>

      <section className="colour-note">
        <div className="colour-block" aria-hidden="true"><span /><span /><span /></div>
        <div>
          <p className="eyebrow">Field note 01</p>
          <h2>Built to interrupt the neutral uniform.</h2>
          <p>Each release starts with a practical need, then uses colour to make construction visible: a pocket traced in blue, a fastening picked out in copper, or a seam that refuses to disappear.</p>
          <Link to="/about" onClick={toTop}>Read our approach</Link>
        </div>
      </section>
    </main>
  );
}

export default Main;
